import React, { useEffect } from 'react';
import Page from './../../components/Page';
import { observer } from 'mobx-react-lite';
import TabSwitcher from '../../components/TabSwitcher';
import Matches from '../Matches/Matches';

const ModusTab = ({ store }) => {
    useEffect(() => {
        store.getTeams();
        store.getQualifications();
    }, [store]);

    const qualifications =
        [37, 38, 39, 40, 27, 18, 2, 3, 4]
            .map((external_id) =>
                (store.qualifications || [])?.find(
                    (qualification) => qualification.external_id === external_id,
                ),
            )
            ?.filter((el) => el)
            ?.map((el) => ({
                ...el,
                name: el.name.replace('Playoff','').trim(),
            })) || [];

    return (
        <Page>
            <TabSwitcher initialTabName={qualifications[0]?.name}>
                <TabSwitcher.Tabs>
                    {qualifications.length > 0 &&
                        qualifications.map((qualification) => {
                            return (
                                <TabSwitcher.TabPill
                                    tabName={qualification.name}
                                    key={`tabName-${qualification.name}`}
                                />
                            );
                        })}
                </TabSwitcher.Tabs>
                {qualifications.length > 0 &&
                    qualifications.map((qualification) => {
                        return (
                            <TabSwitcher.TabPanel
                                key={`tabValue-${qualification.external_id}`}
                                activeWhenTabName={qualification.name}
                            >
                                <Matches
                                    store={store}
                                    isCupGames={true}
                                    qualification_id={qualification.id}
                                />
                            </TabSwitcher.TabPanel>
                        );
                    })}
            </TabSwitcher>
        </Page>
    );
};

export default observer(ModusTab);
